import { REVIEWS } from '../data';

export default function ReviewSlider() {
  // Duplicate the reviews array to create a seamless infinite scroll effect
  const duplicatedReviews = [...REVIEWS, ...REVIEWS, ...REVIEWS];

  return (
    <div className="relative w-full overflow-hidden bg-neutral-light-bg py-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center mb-8">
        <span className="text-xs font-bold uppercase tracking-widest text-secondary-green block mb-2">
          Kundeanmeldelser
        </span>
        <h2 className="font-display text-2xl md:text-3xl font-bold text-primary-green">
          Hvad siger vores kunder?
        </h2>
      </div>

      {/* Infinite Scroll Container */}
      <div className="relative flex w-full overflow-x-hidden">
        {/* Gradient Overlays for smooth fade out on edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-neutral-light-bg to-transparent sm:w-32" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-neutral-light-bg to-transparent sm:w-32" />

        {/* Scrolling Row */}
        <div className="flex gap-6 animate-scroll py-4 px-4">
          {duplicatedReviews.map((review, idx) => (
            <div
              key={idx}
              className="w-[280px] sm:w-[350px] shrink-0 bg-white p-6 rounded-sm border border-gray-100 shadow-xs flex flex-col justify-between transition-all duration-300 hover:shadow-md"
            >
              <div>
                <div className="text-secondary-green text-3xl font-serif leading-none mb-4">”</div>
                <p className="text-xs text-neutral-muted leading-relaxed italic">
                  {review.text}
                </p>
              </div>
              <div className="mt-6 pt-4 border-t border-gray-50 flex items-center justify-between">
                <div>
                  <h4 className="font-display text-xs font-bold text-primary-green uppercase tracking-wider">
                    {review.author}
                  </h4>
                  <p className="text-[10px] text-neutral-muted">
                    {review.location}
                  </p>
                </div>
                <div className="flex gap-0.5 text-yellow-400 text-[10px]">
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                  <i className="fa-solid fa-star" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
